module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/imgadvisor_spotlight_mobile_03@2x-dd17c055932e1eea431e38df687aca7a.jpg";